var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltipDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C3.589 16 0 12.411 0 8C0 3.589 3.589 0 8 0C12.411 0 16 3.589 16 8C16 12.411 12.411 16 8 16ZM8 1C4.14 1 1 4.14 1 8C1 11.86 4.14 15 8 15C11.86 15 15 11.86 15 8C15 4.14 11.86 1 8 1ZM8.35162 9.44643C8.50695 9.44643 8.63286 9.31692 8.63286 9.15714C8.63286 8.5075 8.98197 8.17533 9.35577 7.81965C9.78648 7.40983 10.25 6.96881 10.25 5.975C10.25 4.85659 9.24273 3.95 8.00007 3.95C6.7574 3.95 5.75013 4.85662 5.75013 5.975C5.74785 6.19642 5.77511 6.41712 5.83116 6.63093C5.86547 6.75653 5.97698 6.84323 6.10382 6.84289H6.67508C6.76584 6.84291 6.85097 6.7977 6.9035 6.72159C6.95604 6.64545 6.96943 6.54787 6.93945 6.45976C6.88913 6.30345 6.86441 6.13963 6.86632 5.975C6.86632 5.49568 7.40389 5.10714 7.94736 5.10714C8.49083 5.10714 9.01957 5.49568 9.01957 5.975C9.01957 6.64377 8.67888 6.96318 8.31371 7.30555C7.89198 7.70096 7.43758 8.12698 7.43758 9.15714C7.43758 9.31692 7.56349 9.44643 7.71882 9.44643H8.35162ZM8.84379 11.1821C8.84379 10.7028 8.46605 10.3143 8.00007 10.3143C7.5341 10.3143 7.15637 10.7029 7.15634 11.1821C7.15634 11.6615 7.53408 12.05 8.00007 12.05C8.46605 12.05 8.84379 11.6615 8.84379 11.1821Z",
    fill: "#8A8E96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipDefault);
export default __webpack_public_path__ + "static/media/tooltip-default.8b3f937b4004091abbf9b24d31fa1bbc.svg";
export { ForwardRef as ReactComponent };